// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3i0it","buttons":"SendReceipts_buttons__NwJqE","email":"SendReceipts_email__3jYZn","bookApptTitle":"SendReceipts_bookApptTitle__3liDf"};